import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function ArticlePage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Article",
                "headline": "Der ultimative OOPBUY Spreadsheet Guide 2026: Alles, was du wissen musst",
                "description": "Ein umfassender Leitfaden für OOPBUY Spreadsheet — von den Grundlagen über die besten Kategorien bis hin zu Sicherheitstipps und Verkäuferbewertungen.",
                "image": "https://readdy.ai/api/search-image?query=open%20notebook%20with%20organized%20spreadsheet%20layout%20on%20warm%20beige%20desk%20surface%20soft%20natural%20daylight%2C%20minimalist%20guide%20photography%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20knowledge%20sharing%20concept&width=1600&height=600&seq=article-hero-guide&orientation=landscape",
                "url": "https://oopbuyspread.baby/oopbuy-spreadsheet-guide",
                "inLanguage": "de",
                "datePublished": "2026-07-16",
                "dateModified": "2026-07-16",
                "author": {
                  "@type": "Organization",
                  "name": "OOPBUY Spreadsheet Redaktion",
                  "url": "https://oopbuyspread.baby"
                },
                "publisher": {
                  "@type": "Organization",
                  "name": "OOPBUY Spreadsheet Deutschland",
                  "url": "https://oopbuyspread.baby",
                  "logo": {
                    "@type": "ImageObject",
                    "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg"
                  }
                },
                "mainEntityOfPage": {
                  "@type": "WebPage",
                  "@id": "https://oopbuyspread.baby/oopbuy-spreadsheet-guide"
                }
              },
              {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Startseite",
                    "item": "https://oopbuyspread.baby"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "OOPBUY Spreadsheet Guide"
                  }
                ]
              }
            ]
          })
        }}
      />
      <nav className="sticky top-0 z-50 w-full px-6 md:px-12 py-4 bg-white/95 backdrop-blur-sm border-b border-background-200/70">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="text-foreground-900 font-heading text-lg md:text-xl font-bold tracking-tight whitespace-nowrap">OOPBUY Spreadsheet</span>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-foreground-600 text-sm hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">
              <span className="w-4 h-4 flex items-center justify-center inline mr-1">
                <i className="ri-arrow-left-line text-sm"></i>
              </span>
              Zurück zur Startseite
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hidden sm:inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </nav>

      <main>
        <article className="max-w-4xl mx-auto px-6 md:px-12 py-10 md:py-16">
          <header className="mb-10">
            <div className="flex items-center gap-2 mb-4">
              <Link to="/" className="text-accent-600 text-xs font-medium hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer">
                Startseite
              </Link>
              <span className="text-foreground-400 text-xs">/</span>
              <span className="text-foreground-500 text-xs whitespace-nowrap">OOPBUY Spreadsheet Guide</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              Der ultimative OOPBUY Spreadsheet Guide 2026: Alles, was du wissen musst
            </h1>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Ein umfassender Leitfaden für OOPBUY Spreadsheet — von den Grundlagen über die besten Kategorien bis hin zu Sicherheitstipps und Verkäuferbewertungen. Erfahre, wie du das Beste aus deinem Shopping-Erlebnis herausholst.
            </p>

            <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
              <span className="whitespace-nowrap">Aktualisiert: Juli 2026</span>
              <span className="whitespace-nowrap">Lesezeit: 12 Minuten</span>
              <span className="whitespace-nowrap">Von: OOPBUY Spreadsheet Redaktion</span>
            </div>
          </header>

          <div className="prose-custom">
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                Was ist ein OOPBUY Spreadsheet?
              </h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                Ein <strong>OOPBUY Spreadsheet</strong> ist eine strukturierte und umfassende Produktübersicht, die speziell für Käufer entwickelt wurde, die Wert auf Übersichtlichkeit und Effizienz legen. Stell dir vor, du hättest alle interessanten Produkte aus verschiedenen Kategorien — von <strong>Schuhen</strong> über <strong>Bekleidung</strong> bis hin zu <strong>Accessoires</strong> — an einem zentralen Ort gesammelt. Genau das bietet dir ein OOPBUY Spreadsheet.
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                Die Idee hinter dem Konzept ist einfach, aber wirkungsvoll: Statt mühsam durch unzählige Seiten zu navigieren, findest du in einem OOPBUY Spreadsheet alle relevanten Informationen kompakt aufbereitet. Produktnamen, Preise, Verkäuferbewertungen, QC-Bilder und direkte Links — alles übersichtlich in einer Tabelle angeordnet. Das spart nicht nur Zeit, sondern hilft dir auch, bessere Kaufentscheidungen zu treffen.
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                Zurück zur <Link to="/" className="text-accent-600 hover:text-accent-700 underline whitespace-nowrap">OOPBUY Spreadsheet Startseite</Link> für eine vollständige Kategorienübersicht.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                Warum OOPBUY Spreadsheet so beliebt ist
              </h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                Die wachsende Popularität von OOPBUY Spreadsheet in Deutschland, Österreich und der Schweiz kommt nicht von ungefähr. Hier sind die wichtigsten Gründe, warum immer mehr Käufer auf diese Methode setzen:
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">Riesige Produktauswahl</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Tausende von Artikeln aus verschiedenen Kategorien sind übersichtlich in einem einzigen Spreadsheet organisiert. Von Sneakern bis zu Parfums — du findest alles, was dein Shopping-Herz begehrt.</p>
                </div>
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">Verkäufer vergleichen</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Nicht jeder Verkäufer liefert die gleiche Qualität. Mit einem OOPBUY Spreadsheet kannst du Bewertungen einsehen und nur bei vertrauenswürdigen Anbietern bestellen.</p>
                </div>
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">QC-Informationen verstehen</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Qualitätskontrolle ist beim Online-Shopping entscheidend. Die Spreadsheets enthalten oft QC-Bilder und Bewertungen, damit du genau weißt, was du bekommst.</p>
                </div>
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">Versand optimieren</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Vergleiche Versandmethoden, Lieferzeiten und Kosten für den Versand nach Deutschland. So findest du immer die günstigste und schnellste Option.</p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                Die beliebtesten OOPBUY Spreadsheet Kategorien
              </h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
                Ein gut strukturiertes OOPBUY Spreadsheet deckt viele verschiedene Produktkategorien ab. Hier sind die am häufigsten nachgefragten Kategorien mit einer kurzen Erklärung, was du jeweils erwarten kannst:
              </p>

              <div className="overflow-x-auto mb-6">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-background-300/60">
                      <th className="text-left py-3 px-4 text-foreground-900 font-semibold whitespace-nowrap">Kategorie</th>
                      <th className="text-left py-3 px-4 text-foreground-900 font-semibold whitespace-nowrap">Vorteile</th>
                      <th className="text-left py-3 px-4 text-foreground-900 font-semibold whitespace-nowrap">Geeignet für</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-background-200/70">
                      <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">Sneaker Spreadsheet</td>
                      <td className="py-3 px-4 text-foreground-600">Große Auswahl, gute Preise</td>
                      <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Sneaker Fans</td>
                    </tr>
                    <tr className="border-b border-background-200/70">
                      <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">Fashion Spreadsheet</td>
                      <td className="py-3 px-4 text-foreground-600">Viele Styles, aktuelle Trends</td>
                      <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Streetwear Käufer</td>
                    </tr>
                    <tr className="border-b border-background-200/70">
                      <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">Budget Spreadsheet</td>
                      <td className="py-3 px-4 text-foreground-600">Niedrige Preise, hohe Ersparnis</td>
                      <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Anfänger</td>
                    </tr>
                    <tr className="border-b border-background-200/70">
                      <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">Premium Spreadsheet</td>
                      <td className="py-3 px-4 text-foreground-600">Hochwertige Produkte, beste Qualität</td>
                      <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Erfahrene Nutzer</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">Accessoires Spreadsheet</td>
                      <td className="py-3 px-4 text-foreground-600">Kleine Extras, große Wirkung</td>
                      <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Alle Käufer</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                Auf unserer <Link to="/" className="text-accent-600 hover:text-accent-700 underline whitespace-nowrap">Startseite</Link> findest du eine vollständige Übersicht aller 14 Kategorien mit direkten Links zu den entsprechenden OOPBUY Spreadsheet Listen.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                Schritt für Schritt: So nutzt du OOPBUY Spreadsheet richtig
              </h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
                Wenn du neu im Bereich OOPBUY Spreadsheet bist, kann die Menge an Informationen zunächst überwältigend wirken. Keine Sorge — mit dieser einfachen Schritt-für-Schritt-Anleitung findest du dich schnell zurecht:
              </p>

              <div className="space-y-5">
                <div className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-white text-sm font-bold">1</span>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">Kategorie auswählen</h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">Beginne damit, die für dich passende <strong>OOPBUY Spreadsheet Kategorie</strong> auszuwählen. Ob Schuhe, Kleidung oder Accessoires — jede Kategorie hat ihre eigenen Spreadsheets mit spezifischen Produktlisten.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-white text-sm font-bold">2</span>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">Produkte vergleichen</h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">Nutze die Vergleichsfunktion des Spreadsheets, um verschiedene Produkte nebeneinander zu stellen. Achte besonders auf Preis, Qualität und Verkäuferbewertungen.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-white text-sm font-bold">3</span>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">QC-Bilder prüfen</h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">Bevor du eine Kaufentscheidung triffst, solltest du die QC-Bilder (Quality Control) sorgfältig prüfen. Sie zeigen dir den tatsächlichen Zustand des Produkts und helfen, Enttäuschungen zu vermeiden.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-white text-sm font-bold">4</span>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">Versand auswählen</h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">Wähle die beste Versandoption für deine Bestellung. Für Deutschland sind DHL und EMS die gängigsten Methoden. Vergleiche Kosten und Lieferzeiten.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-white text-sm font-bold">5</span>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">Bestellung aufgeben</h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">Mit allen Informationen aus dem <strong>OOPBUY Spreadsheet</strong> kannst du nun eine informierte Kaufentscheidung treffen und deine Bestellung sicher aufgeben.</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                Ist OOPBUY sicher? — Ein ehrlicher Sicherheitsguide
              </h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                Sicherheit ist beim Online-Shopping das A und O — und das gilt auch für OOPBUY Spreadsheet. Viele Neueinsteiger fragen sich: <strong>Ist OOPBUY sicher?</strong> Die kurze Antwort lautet: Ja, wenn du einige grundlegende Vorsichtsmaßnahmen beachtest.
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                Ein gutes OOPBUY Spreadsheet enthält in der Regel geprüfte Verkäufer mit nachvollziehbaren Bewertungen. Trotzdem solltest du immer selbst kritisch bleiben und folgende Sicherheitsregeln beachten:
              </p>
              <ul className="list-disc list-inside text-foreground-700 text-sm md:text-base leading-relaxed space-y-2 mb-4">
                <li>Überprüfe Verkäuferbewertungen, bevor du eine Bestellung aufgibst</li>
                <li>Achte auf aktuelle QC-Bilder, nicht nur auf Produktfotos aus dem Katalog</li>
                <li>Vergleiche Preise — extrem niedrige Preise können auf minderwertige Qualität hindeuten</li>
                <li>Nutze nur die offiziellen Links aus vertrauenswürdigen OOPBUY Spreadsheet Quellen</li>
                <li>Lies Erfahrungsberichte anderer Käufer in der Community</li>
              </ul>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                Mehr Informationen und aktuelle Sicherheitstipps findest du auf unserer <Link to="/" className="text-accent-600 hover:text-accent-700 underline whitespace-nowrap">OOPBUY Spreadsheet Startseite</Link>.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                Versand nach Deutschland: Was du wissen musst
              </h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                Der Versand von OOPBUY Bestellungen nach Deutschland ist ein wichtiges Thema, das viele Käufer beschäftigt. Je nach gewählter Versandmethode variieren Kosten und Lieferzeit erheblich. Hier ein kurzer Überblick:
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">DHL Versand</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Zuverlässig und schnell. Lieferzeit in der Regel 7-14 Tage. Gute Sendungsverfolgung und zuverlässige Zustellung in ganz Deutschland.</p>
                </div>
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">EMS Versand</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Etwas günstiger als DHL, mit ähnlichen Lieferzeiten von 10-20 Tagen. Gute Option für preisbewusste Käufer.</p>
                </div>
              </div>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                Beachte auch mögliche Zollgebühren bei der Einfuhr nach Deutschland. Informiere dich vorab über die aktuellen Freigrenzen und Einfuhrbestimmungen, um unangenehme Überraschungen zu vermeiden.
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                Weitere Details zu allen <strong>OOPBUY Spreadsheet Kategorien</strong> findest du auf der <Link to="/" className="text-accent-600 hover:text-accent-700 underline whitespace-nowrap">Hauptseite</Link>.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                Häufig gestellte Fragen (FAQ)
              </h2>
              <div className="space-y-4">
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">Was kostet ein OOPBUY Spreadsheet?</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Viele OOPBUY Spreadsheet Listen sind kostenlos verfügbar. Es gibt auch Premium-Versionen mit erweiterten Funktionen, aber für die meisten Nutzer reichen die kostenlosen Varianten völlig aus.</p>
                </div>
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">Wie aktuell sind die Produktlisten?</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Gute OOPBUY Spreadsheet Listen werden regelmäßig aktualisiert. Wir empfehlen, immer die neueste Version zu verwenden, um aktuelle Preise und verfügbare Produkte zu sehen.</p>
                </div>
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">Kann ich OOPBUY Spreadsheet auch in Österreich und der Schweiz nutzen?</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Absolut! Die OOPBUY Spreadsheet Listen funktionieren für die gesamte DACH-Region. Beachte lediglich länderspezifische Zollbestimmungen.</p>
                </div>
                <div className="p-5 bg-background-100 rounded-lg">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">Gibt es eine App für OOPBUY Spreadsheet?</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">Aktuell sind die Spreadsheets primär als Web-Tabellen verfügbar. Du kannst sie aber problemlos auf deinem Smartphone öffnen und nutzen.</p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                Verfügbare Kategorien im Überblick
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 p-3 bg-background-100 rounded-lg text-sm text-foreground-700 hover:bg-accent-100 hover:text-accent-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.nameDe}
                  </a>
                ))}
              </div>
            </section>

            <div className="p-6 md:p-8 bg-primary-50 rounded-lg border border-primary-200/50">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">
                Bereit zum Shoppen?
              </h2>
              <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                Jetzt, wo du alles über OOPBUY Spreadsheet weißt, ist es an der Zeit, selbst loszulegen. Besuche das Hauptportal und entdecke die neuesten Produkte, besten Verkäufer und aktuellsten Spreadsheet-Listen.
              </p>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  oopbuy spreadsheet
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </span>
                </a>
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 text-sm font-medium rounded-full border border-background-300/60 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Zurück zur Übersicht
                </Link>
              </div>
            </div>
          </div>
        </article>
      </main>

      <footer className="px-6 md:px-12 py-10 bg-foreground-950">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="text-white/70 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer">
            &larr; Zurück zur OOPBUY Spreadsheet Startseite
          </Link>
          <p className="text-white/40 text-xs whitespace-nowrap">
            &copy; 2026 OOPBUY Spreadsheet. Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </>
  );
}